"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridCardList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_virtual_1 = require("react-virtual");
var core_1 = require("@material-ui/core");
var styles_1 = require("./styles");
var atoms_1 = require("../../atoms");
var LoadMoreCard_1 = require("../../molecules/LoadMoreCard");
exports.GridCardList = react_1.default.memo(function (_a) {
    var data = _a.data, hasNextPage = _a.hasNextPage, _b = _a.itemSize, itemSize = _b === void 0 ? 250 : _b, _c = _a.threshold, threshold = _c === void 0 ? 5 : _c, isNextPageLoading = _a.isNextPageLoading, loading = _a.loading, _d = _a.loadNextPage, loadNextPage = _d === void 0 ? function () { } : _d, _e = _a.loadMoreIndicatorSize, loadMoreIndicatorSize = _e === void 0 ? 35 : _e, emptyDataText = _a.emptyDataText, minTableWidth = _a.minTableWidth, _f = _a.variant, variant = _f === void 0 ? 'fill' : _f, height = _a.height, offsetHeight = _a.offsetHeight, rfiListOverFlow = _a.rfiListOverFlow, CardComponent = _a.CardComponent, listPadding = _a.listPadding;
    var parentRef = (0, react_1.useRef)();
    var hasData = data && data.length > 0;
    var showData = hasData;
    var isEmpty = !hasData && !loading;
    var isFirstLoad = !hasData && loading;
    var classes = (0, styles_1.useStyles)({
        loading: loading,
        loadMoreIndicatorSize: loadMoreIndicatorSize,
        minTableWidth: minTableWidth,
        hasData: hasData,
        variant: variant,
        height: height,
        offsetHeight: offsetHeight,
        rfiListOverFlow: rfiListOverFlow,
        itemSize: itemSize,
        listPadding: listPadding,
    });
    var rowVirtualizer = (0, react_virtual_1.useVirtual)({
        size: hasNextPage ? data.length + 1 : data.length,
        parentRef: parentRef,
        estimateSize: (0, react_1.useCallback)(function () { return itemSize; }, [itemSize]),
        overscan: threshold,
    });
    var loadMore = (0, react_1.useCallback)(function (entries, observer) {
        if (!isNextPageLoading)
            loadNextPage(entries, observer);
    }, [isNextPageLoading, loadNextPage]);
    var ListItem = react_1.default.memo(function (_a) {
        var vRow = _a.vRow;
        var isLoadMoreRow = vRow.index > data.length - 1;
        var vRowStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            transform: "translateY(".concat(vRow.start, "px)"),
        };
        if (isLoadMoreRow)
            return ((0, jsx_runtime_1.jsx)(core_1.Card, { children: (0, jsx_runtime_1.jsx)(core_1.CardContent, __assign({ style: __assign({ padding: '12px' }, vRowStyle) }, { children: (0, jsx_runtime_1.jsx)(LoadMoreCard_1.LoadMoreCard, { when: hasNextPage, loading: true, onIntersection: loadMore }) })) }));
        return ((0, jsx_runtime_1.jsx)(CardComponent, __assign({}, data[vRow.index], { index: vRow.index, style: __assign({ marginBottom: "12px" }, vRowStyle) })));
    });
    return (
    // TODO: make this not universal
    (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ px: "3px", pt: "5px", pb: "60px", className: classes.rfiList }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.table }, { children: [isFirstLoad && (0, jsx_runtime_1.jsx)(atoms_1.LoadingIndicator, { loading: true }), isEmpty && emptyDataText, showData && ((0, jsx_runtime_1.jsx)("div", __assign({ ref: parentRef, className: classes.list }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                            height: "".concat(rowVirtualizer.totalSize, "px"),
                            position: 'relative',
                            width: '100%',
                        } }, { children: rowVirtualizer.virtualItems.map(function (vRow) { return ((0, jsx_runtime_1.jsx)(ListItem, { vRow: vRow }, vRow.key)); }) })) })))] })) })));
});
